import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage';

import { ensureOnline } from '@/libs/network';
import { getFirebaseApp } from '../init.web';

async function uploadBlobToStorage(filePath: string, storagePath: string, contentType?: string) {
  await ensureOnline();
  const res = await fetch(filePath);
  const blob = await res.blob();
  const storage = getStorage(getFirebaseApp());
  const storageRef = ref(storage, storagePath);
  // Prefer the caller-provided type (videos aren't always tagged on the blob), then the
  // browser-detected blob type, then a JPEG default for legacy image-only callers.
  const resolvedType = contentType || blob.type || 'image/jpeg';
  const task = await uploadBytes(storageRef, blob, { contentType: resolvedType });
  const downloadUrl = await getDownloadURL(storageRef);
  return {
    task,
    downloadUrl,
  };
}

export const uploadImageToStorage = async (filePath: string, storagePath: string) =>
  uploadBlobToStorage(filePath, storagePath, 'image/jpeg');

/**
 * Web counterpart of the native `putFile` helper — fetches the local `blob:` / `data:` URI and
 * uploads via the Firebase JS SDK (`@react-native-firebase/storage` is native-only).
 */
export const uploadFileToStorage = async (
  filePath: string,
  storagePath: string,
  contentType?: string,
) => uploadBlobToStorage(filePath, storagePath, contentType);
